import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PdfViewerComponent } from 'ng2-pdf-viewer';

@Component({
  selector: 'app-viewpdf',
  templateUrl: './viewpdf.component.html',
  styleUrls: ['./viewpdf.component.css']
})
export class ViewpdfComponent {
  @Input() pdfUrl: string = '';
  @Input() namepdf: string = '';
  @Input() modalVisible: boolean = false;
  @Output() modalClosed = new EventEmitter<void>();

  constructor(public pdfViewerComponent: PdfViewerComponent){}

  ngOnInit() {}

  closeModal() {
    this.modalVisible = false;
    this.modalClosed.emit(); // Emitir evento cuando se cierra el modal
  }

}
